var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscribe-bg",class:[_vm.theme]},[_c('div',{staticClass:"subscribe-bg-image"},[_c('div',{staticClass:"home-content"},[_vm._t("subscribe-content")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }